const template = `
	<p class="audi-copy-m carstore-list__error-message">{{=window.i18n['carstore-layer.no-slots-available']}}</p>
`;
export {template as carstoreListEmptyTemplate};
